import React from 'react';
import { Box, Tab } from '@mui/material';
import { TabContext, TabList } from '@mui/lab';

const TabPanel = (props) => {
  const { tabvalue, setTabValue, setSelectedFilters } = props;

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
    setSelectedFilters({
      empCode: '',
      factory: '',
      tag: '',
      isActive: undefined,
    });
  };

  return (
    <>
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={tabvalue}>
          <Box>
            <TabList
              aria-label="lab API tabs example"
              onChange={handleChange}
              sx={{
                '& .MuiTabs-indicator': {
                  display: 'none',
                },
              }}
            >
              <Tab
                label={
                  <div
                    className={`p-4 rounded-md  text-sm  font-bold ${
                      tabvalue === '1'
                        ? 'bg-[#ECF6FF] text-[#333B7A] opacity-100'
                        : 'text-[#333B7A] bg-white opacity-70'
                    } shadow-2xl  font-bold capitalize text-[24px] flex  gap-2 items-center justify-between`}
                  >
                    Active Users
                  </div>
                }
                value="1"
                className="shadow-2xl p-0"
              />
              <Tab
                label={
                  <div
                    className={`p-4 rounded-md  text-sm  font-bold ${
                      tabvalue === '2'
                        ? 'bg-[#ECF6FF] text-[#333B7A] opacity-100'
                        : 'text-[#333B7A] bg-white opacity-70'
                    } shadow-2xl  font-bold capitalize text-[24px]  flex  gap-2 items-center justify-between`}
                    onChange={handleChange}
                  >
                    All users
                  </div>
                }
                value="2"
                className="shadow-2xl p-0"
              />
            </TabList>
          </Box>

          {/* React Table */}
        </TabContext>
      </Box>
    </>
  );
};

export default TabPanel;
